import styled, { createGlobalStyle } from 'styled-components'

import mq from '../../../utils/styled-mq'
import { px2rem, hiDPIpx } from '../../../utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const mID = 'otm-latest-press-images'
const isAB = getEnvConfig.fe.theme === 'artbasel'

export const GlobalStyles = createGlobalStyle`
  ${
    isAB &&
    `
    #prio .site-modules > section.otm-latest-press-images:first-of-type {
      @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
        margin-top: ${hiDPIpx(110)} !important;
      }
      @media (max-width: ${MFP.vars.largestMobileScreen}) {
        margin-top: ${px2rem(75)} !important;
      }
    }

  .slick-slide .stretched.row .eight.column {
    @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
      margin-bottom: ${hiDPIpx(23)} !important;
    }
    @media (max-width: ${MFP.vars.largestMobileScreen}) {
      margin-bottom: ${px2rem(23)} !important;
    }
  }

  .slick__navigation-controls {
    a {
      max-width: ${px2rem(19)};
    }
    top: -${px2rem(26)} !important;

    @media (max-width: ${MFP.vars.largestTabletScreen}) {
      height: auto !important;
    }
    @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
      border-top: ${hiDPIpx(1)} solid ${tokens.color.light.base.neutrals['400'].value};
      border-bottom: ${hiDPIpx(1)} solid ${tokens.color.light.base.neutrals['400'].value};
      padding: ${hiDPIpx(18)} 0;
      a {
        height: ${hiDPIpx(30)};
      }
    }
    @media (max-width: ${MFP.vars.largestMobileScreen}) {
      border-top: ${px2rem(1)} solid ${tokens.color.light.base.neutrals['400'].value};
      border-bottom: ${px2rem(1)} solid ${tokens.color.light.base.neutrals['400'].value};
      padding: ${px2rem(18)} 0;
      a {
        height: ${px2rem(30)};
      }
    }

    &-num {
      height: ${px2rem(30)};
      align-content: center;
      align-items: center;
      ${mq.greaterThan('desktop')` display: flex; `};
      margin: ${px2rem(2)} ${px2rem(10)} !important;

      span {
        @media (max-width: ${MFP.vars.largestTabletScreen}) {
          position: relative;
        }
      }

      &-first {
        font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      }

      &-slash {
        margin: 0 ${px2rem(5)};
      }
    }
  }`
  }
`

export const Styles = styled.section`
  ${mq.between('tablet', 'largestTablet')` padding-bottom: 0; margin-bottom: ${px2rem(62)}`};
  ${mq.lessThan('largestMobile')` padding-bottom: 0; margin-bottom: ${px2rem(41)}`};
  ${isAB &&
  `
    margin-bottom: ${px2rem(70)} !important;

    @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
      margin-bottom: ${hiDPIpx(38)} !important;
    }
    @media (max-width: ${MFP.vars.largestMobileScreen}) {
      margin-bottom: ${px2rem(38)} !important;
    }
  `}

  .slick__navigation-controls {
    display: flex;
    align-items: center;

    @media (min-width: 768px) {
      margin-top: 30px;
    }
  }

  img {
    width: 100%;
  }

  figure {
    margin: 0 !important;
  }

  .${mID} {
    &__header-grid {
      margin-top: -${px2rem(7)};
      margin-bottom: ${px2rem(isAB ? 37 : 47)};
      ${mq.between('tablet', 'largestTablet')`margin-bottom: ${px2rem(33)}`};
      ${mq.lessThan('largestMobile')`margin-bottom: ${px2rem(22)}`};
      ${isAB &&
      `.four.column {
        align-items: center;
        display: flex;

        .call-to-action {
          text-align: right;
          position: relative;
          top: ${px2rem(9)};

          svg {
            margin-right: -${px2rem(6)};
            height: ${px2rem(20)};
            width: ${px2rem(13)};
          }
        }
      }
      `}
      & > .row {
        padding-top: 0;
      }
    }

    &__right-column {
      display: flex;
      flex-direction: column;
      ${mq.greaterThan('desktop')` ${isAB && `margin-top: -${px2rem(16)}; `} `};
      ${mq.lessThan('largestMobile')` margin-bottom: ${px2rem(25)} `};

      > a:first-of-type + .call-to-action {
        margin-top: ${px2rem(15)};
      }

      h3 {
        margin: ${px2rem(16)} 0 ${px2rem(20)};
        ${mq.between('tablet', 'largestTablet')`margin: ${px2rem(32)} 0 ${px2rem(20)}`};
        ${mq.lessThan('largestMobile')`margin: 0 0 ${px2rem(13)}`};
      }

      h4 {
        ${mq.between('tablet', 'largestTablet')`margin-bottom: ${hiDPIpx(13)};`};
        ${mq.lessThan('largestMobile')`margin-bottom: ${px2rem(13)}`};
      }
    }

    &__author {
      margin-bottom: 0;
      ${mq.greaterThan('desktop')` ${isAB && `margin-top: ${px2rem(19)} !important; `} `};
    }

    &__caption {
      color: var(--bs-mch-gray-500);
      display: inline-block;
    }

    &__copyright {
      ${mq.lessThan('largestTablet')`padding: 0;margin: 0`};
    }

    &__download {
      margin-top: ${px2rem(isAB ? 19 : 13)};
      ${mq.between('tablet', 'largestTablet')`margin-top: ${px2rem(30)}; margin-bottom: ${px2rem(33)}`};
      ${mq.lessThan('largestMobile')`margin-top: ${px2rem(20)}; `};
      ${isAB && `span { font-weight: ${tokens.fontWeights.artBaselHeadline0.value}; }`}
    }

    &__more-grid.ui.grid {
      margin-top: ${px2rem(57)};
      ${!isAB &&
      `
        @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
          margin-top: ${hiDPIpx(23)};
        }
        @media (max-width: ${MFP.vars.largestMobileScreen}) {
          margin-top: ${px2rem(23)};
        }
      `}

      ${isAB &&
      `
        @media (max-width: ${MFP.vars.largestTabletScreen}) {
          margin-top: 0 !important;
        }

        .${mID}__more-row {
          @media (min-width: ${MFP.vars.tabletBreakpoint}) and (max-width: ${MFP.vars.largestTabletScreen}) {
            margin-top: ${hiDPIpx(12)};
            padding: 0;
          }
          @media (max-width: ${MFP.vars.largestMobileScreen}) {
            margin-top: ${px2rem(12)};
            padding: 0;
          }

          .column {
            a {
              @media (max-width: ${MFP.vars.largestTabletScreen}) {
                svg {
                  float: right;
                }
              }
            }
          }
        }
      `}

      & > .row {
        padding-bottom: 0;
        margin-bottom: ${px2rem(3)};
        ${mq.lessThan('largestTablet')` ${isAB && 'float: right; '} `}
      }
    }
  }
`
